export default __webpack_public_path__ + "static/media/arihant_logo.609a513a.jpeg";